var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Btn_Messages",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 152.42,
    height: 155,
    viewBox: "0 0 152.42 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 152.42,
    height: 155,
    fill: "#1152e4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M126.169,38.537H107.132a28.08,28.08,0,0,0,.547-4.982,33.554,33.554,0,1,0-67.109,0,28.073,28.073,0,0,0,.547,4.982H26.252A26.281,26.281,0,0,0,0,64.789v40.76A26.281,26.281,0,0,0,26.252,131.8h.489l-5.077,16.922a4.874,4.874,0,0,0,6.827,5.772l44.657-22.038a4.856,4.856,0,0,0,.992-.656h52.029a26.282,26.282,0,0,0,26.252-26.252V64.789a26.282,26.282,0,0,0-26.252-26.252M74.125,9.749a23.833,23.833,0,0,1,23.8,23.806c0,3.314-1.808,13-13.915,40.637-3.586,8.186-7.2,15.927-9.89,21.57-2.691-5.643-6.3-13.383-9.89-21.57C52.127,46.555,50.32,36.869,50.32,33.555a23.832,23.832,0,0,1,23.8-23.806",
    transform: "translate(0)",
    fill: "#1152e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M121.838,45.4a16.889,16.889,0,1,0-16.889,16.889A16.909,16.909,0,0,0,121.838,45.4m-24.029,0a7.14,7.14,0,1,1,7.14,7.139,7.148,7.148,0,0,1-7.14-7.139",
    transform: "translate(-30.824 -9.979)",
    fill: "#1152e4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageActive);
export default __webpack_public_path__ + "static/media/message-active.45e4234f97e7e85eb8f30ed4f983ff4f.svg";
export { ForwardRef as ReactComponent };